var React = require('react');

function Webcam (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M224 96a128 128 0 1 0 128 128A128 128 0 0 0 224 96zm0 80a48.05 48.05 0 0 0-48 48 16 16 0 0 1-32 0 80.09 80.09 0 0 1 80-80 16 16 0 1 1 0 32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M401 438.6l-49.19-30.75C409.88 367.39 448 300.19 448 224 448 100.29 347.71 0 224 0S0 100.29 0 224c0 76.19 38.12 143.39 96.23 183.85L47 438.6a32 32 0 0 0-15 27.14V480a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32v-14.26a32 32 0 0 0-15-27.14zM224 384a160 160 0 1 1 160-160 160 160 0 0 1-160 160z","className":"fa-primary","key":2})]);
}

Webcam.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Webcam;

Webcam.default = Webcam;
